import React, { useState, useEffect } from 'react';
import getAuthData from '../../auth/getAuthData';
import styles from './index.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassHalf, faDrumstickBite } from '@fortawesome/free-solid-svg-icons';

// Components
import { Button } from 'react-bootstrap';
import ClockList from './ClockList';
import AuthModal from '../../components/AuthModal';


const OtherButtons = (props) => {
    return (
        <>
            {props.clock.clockStatus === 'clock-in' && <Button variant="primary" className={styles.ActionButton} onClick={() => props.authorize('lunch-in')}>
                <FontAwesomeIcon className={styles.Icon} icon={faDrumstickBite} />
                <span>Empezar Lunch</span>
            </Button>}
            {props.clock.clockStatus === 'lunch-in' && <Button variant="warning" className={styles.ActionButton} onClick={() => props.authorize('lunch-out')}>
                <FontAwesomeIcon className={styles.Icon} icon={faDrumstickBite} />
                <span>Terminar Lunch</span>
            </Button>}
            {(props.clock.clockStatus === 'lunch-out' || props.clock.clockStatus === 'clock-in') && <Button variant="danger" className={styles.ActionButton} onClick={() => props.authorize('clock-out')}>
                <FontAwesomeIcon className={styles.Icon} icon={faHourglassHalf} />
                <span>Tiempo de Salida</span>
            </Button>}
        </>
    )
};

const ClockScreen = (props) => {
    const [clock, setClock] = useState();
    const [showAuth, setShowAuth] = useState(false);
    const [authAction, setAuthAction] = useState();

    const startClock = async () => {
        const auth = getAuthData();
        const url = `${process.env.REACT_APP_API_URL}/clocks/${auth.userData.id}`;
        const request = await fetch(url, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${auth.token}`
            }
        });

        if (request.status === 201) {
            const response = await request.json();
            setClock(response);
        }
    }

    const loadClocks = async () => {
        const auth = getAuthData();
        const url = `${process.env.REACT_APP_API_URL}/clocks/current/${auth.userData.id}`;

        const request = await fetch(url, {
            headers: {
                "Authorization": `Bearer ${auth.token}`
            }
        });

        if (request.status === 200) {
            const response = await request.json();
            setClock(response);
        }
    }

    const updateClock = async (status) => {
        switch (status) {
            case "clock-in":
                startClock();
                break;
            default:
                const auth = getAuthData();
                const url = `${process.env.REACT_APP_API_URL}/clocks/${status}/${auth.userData.id}`;

                const request = await fetch(url, {
                    method: "PATCH",
                    headers: {
                        "Authorization": `Bearer ${auth.token}`
                    }
                });

                if (request.status === 200) {
                    const response = await request.json();
                    setClock(response);
                }
        }

    }

    const isClockReady = () => {
        if (!clock)
            return true;

        if (clock !== null) {
            if (clock.clockStatus === "clock-out")
                return true;
        }

        return false
    }

    const authorize = (action) => {
        setAuthAction(action);
        setShowAuth(true);
    };

    useEffect(() => {
        loadClocks();
    }, []);

    return (
        <section className={styles.ClockScreen}>
            <div className={styles.Heading}>
                <h4 className={styles.Title}>Tiempo</h4>
                <div className={styles.Actions}>
                    {isClockReady() && <Button variant="success" className={styles.ActionButton} onClick={() => authorize('clock-in')}>
                        <FontAwesomeIcon className={styles.Icon} icon={faHourglassHalf} />
                        <span>Tiempo de Entrada</span>
                    </Button>}
                    {clock && <OtherButtons clock={clock} authorize={authorize} />}
                </div>
            </div>
            <ClockList clock={clock} />
            <AuthModal
                show={showAuth}
                hide={() => setShowAuth(false)}
                userData={props.userData}
                func={() => updateClock(authAction)}
                signInDisabled />
        </section>
    )
};

export default ClockScreen;